module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('el-col', {
    attrs: {
      "align": "left"
    }
  }, [(!_vm.hidePanel) ? _c('edit-pane', {
    ref: "tpe",
    attrs: {
      "prefix": "Ticket: ",
      "title": this.formatCategory(_vm.ticket.category),
      "is-edit": _vm.editMode
    },
    on: {
      "save": _vm.onSave,
      "cancel": _vm.onCancel,
      "delete": _vm.onDelete,
      "edit": _vm.onEdit,
      "add": _vm.onSave
    }
  }) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Ticket Ref: "), _c('b', [_c('a', {
    attrs: {
      "href": 'mailto:?subject=re: Ticket ' + _vm.ticketRef + ' - ' + _vm.localData.category + ' for: ' + _vm.localData.site.siteName + ' [Status: ' + _vm.localData.status + ']'
    }
  }, [_vm._v(_vm._s(_vm.ticketRef))])])]), _vm._v(" "), _c('el-form', {
    ref: "maintForm",
    attrs: {
      "model": _vm.ticket,
      "label-width": "120px"
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": this.isTowerCo() ? 'card' : ''
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Issue"
    }
  }, [(!_vm.localSiteId) ? _c('select-site', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.localData.site_id),
      callback: function($$v) {
        _vm.$set(_vm.localData, "site_id", $$v)
      },
      expression: "localData.site_id"
    }
  }) : _vm._e(), _vm._v(" "), _c('select-ticket-category', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.localData.category),
      callback: function($$v) {
        _vm.$set(_vm.localData, "category", $$v)
      },
      expression: "localData.category"
    }
  }), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8,
      "hg": 8
    }
  }, [_c('select-action-status', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.localData.status),
      callback: function($$v) {
        _vm.$set(_vm.localData, "status", $$v)
      },
      expression: "localData.status"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8,
      "hg": 8
    }
  }, [_c('select-priority', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.localData.priority),
      callback: function($$v) {
        _vm.$set(_vm.localData, "priority", $$v)
      },
      expression: "localData.priority"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8,
      "hg": 8
    }
  }, [_c('date-input', {
    attrs: {
      "label": "Target",
      "options": _vm.dateOptions,
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.ticket.target),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "target", $$v)
      },
      expression: "ticket.target"
    }
  })], 1)], 1), _vm._v(" "), (this.isTowerCo() && _vm.ticket.status === 'Completed' || _vm.ticket.status === 'Closed') ? _c('el-row', [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8,
      "hg": 8
    }
  }, [_c('switch-input', {
    attrs: {
      "label": "Completed?",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.ticket.completed),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "completed", $$v)
      },
      expression: "ticket.completed"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8,
      "hg": 8
    }
  }, [_c('date-input', {
    attrs: {
      "label": "Actual Closed",
      "options": _vm.dateOptions,
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.ticket.completedDate),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "completedDate", $$v)
      },
      expression: "ticket.completedDate"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('html-input', {
    attrs: {
      "label": "Issue",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.ticket.issue),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "issue", $$v)
      },
      expression: "ticket.issue"
    }
  }), _vm._v(" "), (!this.isTowerCo()) ? _c('div', [_c('strong', [_vm._v("Reported by: " + _vm._s(_vm.ticket.organisation.name))])]) : _c('div', [_c('select-organisation', {
    attrs: {
      "type": "Telco|Landlord|Tower Supplier|Utility|Backhaul|Tower Company",
      "label": "Reported by",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.localData.organisation_id),
      callback: function($$v) {
        _vm.$set(_vm.localData, "organisation_id", $$v)
      },
      expression: "localData.organisation_id"
    }
  })], 1), _vm._v(" "), (this.isTowerCo()) ? _c('div', [_c('select-contractor', {
    attrs: {
      "label": "Contractor",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.ticket.contractor_id),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "contractor_id", $$v)
      },
      expression: "ticket.contractor_id"
    }
  })], 1) : _c('div', [(_vm.ticket.contractor) ? _c('strong', [_vm._v("Contractor: " + _vm._s(_vm.ticket.contractor.name))]) : _vm._e()])], 1), _vm._v(" "), (this.isTowerCo()) ? _c('el-tab-pane', {
    attrs: {
      "label": "Details"
    }
  }, [_c('html-input', {
    attrs: {
      "label": "Caused by",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.ticket.cause),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "cause", $$v)
      },
      expression: "ticket.cause"
    }
  }), _vm._v(" "), _c('html-input', {
    attrs: {
      "label": "Fixed by",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.ticket.fix),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "fix", $$v)
      },
      expression: "ticket.fix"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', [(_vm.ticket && _vm.ticket.id) ? _c('el-form-item', {
    attrs: {
      "label": "Attachments"
    }
  }, [_c('files-panel', {
    attrs: {
      "type": "site",
      "id": _vm.ticket.site_id,
      "process": _vm.processKey,
      "process-id": _vm.ticket.id,
      "disabled": _vm.disabled
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('html-input', {
    attrs: {
      "label": "Remarks",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.ticket.remarks),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "remarks", $$v)
      },
      expression: "ticket.remarks"
    }
  })], 1), _vm._v(" "), (_vm.localData.site) ? _c('site-card', {
    attrs: {
      "site-data": _vm.localData.site,
      "map-right": ""
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.localData && _vm.rowData.updated_at) ? _c('el-col', {
    attrs: {
      "align": "right",
      "span": 24
    }
  }, [_c('small', [_vm._v("Last Update ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.formatFriendlyDate(_vm.rowData.updated_at)))]), (_vm.rowData.updated_by) ? _c('span', [_vm._v(" by " + _vm._s(_vm.rowData.updated_by))]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3037f830"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tables/details/TicketDetails.vue
// module id = 1477
// module chunks = 0